import React from "react";
import styles from "./button.module.scss";

interface ButtonProps {
    type?: "button" | "submit";
    variant?: "primary" | "secondary" | "ghost";
    href?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
    type = "button",
    variant = "primary",
    href,
    onClick,
    disabled = false,
    className,
    children,
}) => {
    const classes = [styles["button"], styles[variant], className]
        .filter(Boolean)
        .join(" ");

    if (href) {
        return (
            <a href={href} className={classes}>
                {children}
            </a>
        );
    }

    return (
        <button
            type={type}
            className={classes}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default Button;
